import { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '@/App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { ArrowLeft, Mail } from 'lucide-react';
import { toast } from 'sonner';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success('Email envoye');
    } catch {
      toast.error('Erreur');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#f1f5f9] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold text-[#1A4D2E] tracking-wider">SSCaraïbes.com</h1>
        </div>

        <div className="bg-white rounded-xl border border-border/50 shadow-sm p-6">
          {sent ? (
            <div className="text-center space-y-4">
              <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mx-auto">
                <Mail className="h-6 w-6 text-emerald-600" />
              </div>
              <h2 className="font-heading font-semibold text-lg">Email envoye</h2>
              <p className="text-sm text-muted-foreground">
                Si un compte existe avec cette adresse, vous recevrez un lien de reinitialisation.
              </p>
              <p className="text-xs text-muted-foreground">Pensez a verifier vos spams.</p>
              <Link to="/login" className="text-sm text-primary hover:underline">
                Retour a la connexion
              </Link>
            </div>
          ) : (
            <>
              <h2 className="font-heading font-semibold text-lg mb-1">Mot de passe oublie</h2>
              <p className="text-sm text-muted-foreground mb-5">
                Entrez votre email pour recevoir un lien de reinitialisation.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <Label>Email</Label>
                  <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" required data-testid="forgot-email-input" />
                </div>
                <Button type="submit" className="w-full rounded-full" disabled={loading} data-testid="forgot-submit-btn">
                  {loading ? 'Envoi...' : 'Envoyer le lien'}
                </Button>
              </form>
              <div className="mt-4 text-center">
                <Link to="/login" className="text-sm text-muted-foreground hover:text-primary inline-flex items-center gap-1">
                  <ArrowLeft className="h-3 w-3" /> Retour a la connexion
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
